module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-top-ties.93c038e5.png";